export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10679.e3bfdda9.jpg";